import React from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import CustomStoryCard4 from "../../molecules/CustomStoryCard4";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import CustomStoryCard2 from "../../molecules/CustomStoryCard2";
import { getSlug, getCollectionName } from "../../utils/utils";

import "./fiveVideoStories.m.css";

const FiveVideoStories = ({ collection, sections, domainSlug }) => {
  if (!(collection && collection.items && collection.items.length)) {
    return null;
  }

  const stories =
    collection.items.length > 0 && collection.items.filter((item) => item.type === "story").map((item) => item.story);

  if (stories.length < 0) {
    return null;
  }

  const firstStory = stories.length > 0 && stories[0];
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const collectionName = getCollectionName(collection, navigateToTitle);

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);

  return firstStory ? (
    <div styleName="five-story-5s" className="five-story-5s" data-testid="5s-story">
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionName={collectionName}
          collectionSlug={collectionSlug}
          headlineClassName="collection-name"
          updatedFont={true}
        />
      )}
      {firstStory && (
        <CustomStoryCard2
          story={firstStory}
          isSection={false}
          isImageCaptionRequired={false}
          aspectRatio={[16, 9]}
          imageType="image16x9"
          headlineType={32}
          darkTheme={true}
          largeIcon={true}
          updatedFont={true}
          src="five-video-stories"
          updateSubHeadline={true}
          widths={global.deviceWidth < 876 ? [400] : [250, 480, 764]}
        />
      )}
      <div styleName="thumb-story-container">
        {stories.length > 1 &&
          stories
            .splice(1, 4)
            .map((item) => (
              <CustomStoryCard4
                key={item.id}
                story={item}
                headerLevel={4}
                headlineType={12}
                widths={[300]}
                darkTheme={true}
                updatedFont={true}
                src="five-video-stories"
                updateSubHeadline={true}
              />
            ))}
      </div>
    </div>
  ) : null;
};

FiveVideoStories.propTypes = {
  collection: object,
  sections: array,
  domainSlug: string,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps)(FiveVideoStories);
